import React from 'react'
import { Link } from "react-router-dom";


function Navber() {
  return (
    <div className='nav'>
        <div className='logo'><Link className="link" to="/">ToDo</Link></div>
        <nav className='menu'>
        <ul>
          <li>
            <Link className="link" to="/">Home</Link>
          </li>
          <li>
            <Link className="link" to="/news">News</Link>
          </li>
          <li>
            <Link className="link" to="/contact">Contact</Link>
          </li>
        </ul>
        </nav>
    </div>
  )
}

export default Navber